import React from "react";
import moment from "moment";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

// MDB Shims Imports
import Button from "../../Component/MDBShim/Button";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import Col from "../../Component/MDBShim/Col";
import Row from "../../Component/MDBShim/Row";
import Input from "../../Component/MDBShim/Input";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBCol from "../../Component/MDBShim/MDBCol";

//MUI Imports
import MUIAutocomplete from "@mui/material/Autocomplete";
import MUITextField from "@mui/material/TextField";
import MUICloseIcon from "@mui/icons-material/Close";
import MUISearchIcon from "@mui/icons-material/Search";
import MUISaveIcon from "@mui/icons-material/Save";
import MUIBackspaceIcon from "@mui/icons-material/Backspace";

import Moment from "moment";
import "./filterStyle.css";
import UserService from "../Security/UserService/userService";
import PropTypes from "prop-types";
import Select from "react-select";
import QuickFilter from "./quickFilter";
import ReactTooltip from "react-tooltip";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import Setting from "../../Utility/Setting";
import MainContext from "../../Context/MainContext/MainContext";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});

export default class UserFilters extends React.Component {
  constructor(props) {
    super(props);

    this.newSearchFunction = props.newSearchFunction;

    this.theme = props.theme;

    let f = props.userFilters,
      otherUsers = f.user ? f.user.slice(0) : [],
      startDate = f.startDate
        ? new Date(f.startDate)
        : Moment().subtract(11, "months").toDate(),
      endDate = f.endDate ? new Date(f.endDate) : new Date(),
      filterOptions = QuickFilter.getOptions(),
      filterSelected = null,
      selectedLocations = [],
      statuses = [],
      reasons = [],
      users = [];

    let statusOptions = [
      { label: "New", value: "0" },
      { label: "In Process", value: "1" },
      { label: "Ready to Deliver", value: "2" },
      { label: "Setup", value: "3" },
      { label: "Cancelled", value: "4" },
    ];

    if (f.status && f.status.length > 0) {
      statuses = f.status.map((x) => x.statusValue);
    }
    if (f.statuses && f.statuses.length > 0) {
      statuses = f.statuses;
    }

    if (
      f.userprofileLocations &&
      f.userprofileLocations.length > 0 &&
      props.shouldOverride
    ) {
      selectedLocations = f.userprofileLocations.map((x) => x.locationsId);
    }

    if (
      f.userpreferenceInternalLocation &&
      f.userpreferenceInternalLocation.length > 0 &&
      !props.shouldOverride
    ) {
      selectedLocations = f.userpreferenceInternalLocation.map(
        (x) => x.internalLocationId,
      );
    }
    if (
      f.userpreferenceReason &&
      f.userpreferenceReason.length > 0 &&
      !props.shouldOverride
    ) {
      reasons = f.userpreferenceReason.map((x) => x.reasonId);
    } else if (f.reasonIds) {
      reasons = f.reasonIds;
    }

    if (
      f.userpreferenceUser &&
      f.userpreferenceUser.length > 0 &&
      !props.shouldOverride
    ) {
      users = f.userpreferenceUser.map((x) => x.userId);
    }

    let eqIds = [];
    if (
      f.userpreferenceEquipment &&
      f.userpreferenceEquipment.length > 0 &&
      !props.shouldOverride
    ) {
      eqIds = f.userpreferenceEquipment.map((x) => x.equipmentId);
    }

    let itIds = [];
    let istIds = [];
    if (
      f.userpreferenceInsurance &&
      f.userpreferenceInsurance.length > 0 &&
      !props.shouldOverride
    ) {
      itIds = f.userpreferenceInsurance.map((x) =>
        x.payors && x.payors.length > 0 ? x.payors.split(",") : [],
      );
      istIds = f.userpreferenceInsurance.map((x) =>
        x.insurance && x.insurance.length > 0 ? x.insurance.split(",") : [],
      );
    }

    if (
      f.userpreferenceInternalLocation &&
      f.userpreferenceInternalLocation.length > 0 &&
      !props.shouldOverride
    ) {
      selectedLocations = f.userpreferenceInternalLocation.map(
        (x) => x.internalLocationId,
      );
    }

    //let rIds = [];
    //if (f.userpreferenceReason && f.userpreferenceReason.length > 0 && !props.shouldOverride) {
    //	rIds = f.userpreferenceReason.map(x => x.reasonId);
    //}

    if (
      f.userpreferenceStatus &&
      f.userpreferenceStatus.length > 0 &&
      !props.shouldOverride
    ) {
      statuses = f.userpreferenceStatus.map((x) => x.statusValue);
    }

    //check for null and empty string because 0 could be a value...BC
    if (f.dateFilterType != null && f.dateFilterType !== "") {
      //9 is custom
      if (f.dateFilterType === 9) {
        if (f.startDate) {
          startDate = new Date(f.startDate);
        }

        if (f.endDate) {
          endDate = new Date(f.endDate);
        }
      } else {
        let a = QuickFilter.getDates(f.dateFilterType);

        startDate = a[0];
        endDate = a[1];
      }
    }

    if (f.dateFilterType != null) {
      let v = filterOptions.find((o) => {
        return o.value === f.dateFilterType;
      });

      if (v) {
        filterSelected = v;
      }
    }

    this.state = {
      userFilters: f,
      startDate: startDate,
      endDate: endDate,
      dateFilterType: f.dateFilterType || 0,
      searchText: f.q || "",
      equipmentIds:
        f.equipment && f.equipment.length > 0
          ? f.equipment.map((x) => x.equipmentId)
          : eqIds,
      insuranceIds:
        f.insurance && f.insurance.length > 0 && f.insurance[0].payors
          ? f.insurance[0].payors.split(",").map((x) => parseInt(x))
          : itIds,
      insuranceSelected:
        f.insurance && f.insurance.length > 0 && f.insurance[0].payors
          ? f.insurance[0].payors.split(",").map((x) => parseInt(x))
          : itIds,
      insuranceSubTypeIds:
        f.insurance && f.insurance.length > 0 && f.insurance[0].insurance
          ? f.insurance[0].insurance.split(",").map((x) => parseInt(x))
          : istIds,
      insuranceSubTypeSelected:
        f.insurance && f.insurance.length > 0 && f.insurance[0].insurance
          ? f.insurance[0].insurance.split(",").map((x) => parseInt(x))
          : istIds,
      statuses: statuses || [],
      selectedStatuses: statuses || [],
      reasonIds: reasons || [],
      selectedReasonIds: reasons || [],
      locationIds: selectedLocations || [],
      selectedLocations: selectedLocations || [],
      clinicLocations: f.seatingClinics || [],
      users: users,
      groupingColumns: props.groupingColumns || f.groupColumns,
      defaultHiddenColumns:
        props.defaultHiddenColumns || f.defaultHiddenColumns,
      dob: null,
      breakWidth: 1300,
      windowWidth: 0,
      locationsRadio: f.salesServiceClinic || "Sales",
      allEquipment: [],
      allInsurances: [],
      allInsuranceSubTypes: [],
      filteredInsuranceSubTypes: [],
      allLocations: [],
      allStatuses: [],
      allReasons: [],
      availableReasons: [],
      allSalesReps: [],
      filteredSalesReps: [],
      orderModalOpen: false,
      shouldOverride: props.shouldOverride || false,
      showDatePicker: true,
      quickFilter: [],
      quickFilterOptions: filterOptions,
      quickFilterSelected: filterSelected,
      otherUsers: otherUsers,
      orderId: "",

      statusOptions: statusOptions,
    };
  }

  static contextType = MainContext; // For legacy class components

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.groupingColumns !== this.state.groupingColumns) {
      this.setState({
        groupingColumns: nextProps.groupingColumns,
      });
    }

    if (nextProps.defaultHiddenColumns !== this.state.defaultHiddenColumns) {
      this.setState({
        defaultHiddenColumns: nextProps.defaultHiddenColumns,
      });
    }
  }

  componentDidMount() {
    this.getStatusOptions();
    this.getReasonOptions();

    this.getLocationOptions();
    this.getSalesRepOptions();
    this.getEquipmentOptions();
    this.getInsuranceTypes();
    this.getInsuranceSubTypes();

    this.newSearchPass();
  }

  componentDidUpdate() {
    const {
      productTypes,
      reasons,
      salesReps,
      allLocations,
      insuranceTypes,
      insuranceSubTypes,
    } = this.context;
    if (allLocations.length !== this.state.allLocations.length) {
      this.getLocationOptions();
    }
    if (reasons.length !== this.state.allReasons.length) {
      this.getReasonOptions();
    }
    if (insuranceTypes.length !== this.state.allInsurances.length) {
      this.getInsuranceTypes();
    }
    if (insuranceSubTypes.length !== this.state.allInsuranceSubTypes.length) {
      this.getInsuranceSubTypes();
    }
    if (salesReps.length !== this.state.allSalesReps.length) {
      this.getSalesRepOptions();
    }
    if (productTypes.length !== this.state.allEquipment.length) {
      this.getEquipmentOptions();
    }
  }

  handleResize = () =>
    this.setState({
      windowWidth: window.innerWidth,
    });

  newSearchPass() {
    const { currentUser } = this.context;

    let st = this.state,
      filters = {};

    if (st.quickFilter == null || st.quickFilter.length === 0) {
      if (
        st.startDate == null ||
        st.startDate === "" ||
        st.endDate == null ||
        st.endDate === ""
      ) {
        NotistackEnqueueSnackbar(
          "You must select a quick date range or input custom start and end dates",
          { variant: "error" },
        );
        return;
      }
    }

    if (st.quickFilter && st.quickFilter[0] != null) {
      filters.start = st.quickFilter[0].toLocaleDateString();
    } else {
      filters.start = st.startDate.toLocaleDateString();
    }

    if (st.quickFilter && st.quickFilter[1] != null) {
      filters.end = st.quickFilter[1].toLocaleDateString();
    } else {
      filters.end = st.endDate.toLocaleDateString();
    }

    //This should run when we load the page for auto populating the list...BC
    if (st.selectedStatuses && st.selectedStatuses.length > 0) {
      //let temp = [];
      //st.statuses.forEach(s => {
      //	temp.push(stats.indexOf(s));
      //})
      filters.status = []; //st.selectedStatuses.map(x => typeof x === "string" ? stats.indexOf(x) : x);

      st.selectedStatuses.forEach((s) => {
        switch (s) {
          case "New":
            filters.status.push("0");
            break;
          case "InProcess":
          case "In Process":
            filters.status.push("1");
            break;
          case "Ready To Deliver":
          case "Ready to Deliver":
          case "ReadyToDeliver":
            filters.status.push("2");
            break;
          case "Setup":
          case "Set Up":
            filters.status.push("3");
            break;
          case "Cancelled":
            filters.status.push("4");
            break;
          default:
            filters.status.push(s);
            break;
        }
      });
    }

    if (st.selectedReasonIds && st.selectedReasonIds.length > 0) {
      filters.reasons = st.selectedReasonIds.toString();
    }

    filters.locType = st.locationsRadio;

    if (st.equipmentIds && st.equipmentIds.length > 0) {
      filters.equipment = st.equipmentIds.toString();
    }
    //TODO - uncomment
    if (st.insuranceSelected && st.insuranceSelected.length > 0) {
      filters.payors = st.insuranceSelected.toString();
    }
    if (st.insuranceSubTypeSelected && st.insuranceSubTypeSelected.length > 0) {
      filters.insurance = st.insuranceSubTypeSelected.toString();
    }

    //Don't let sales reps see anything except orders assigned to them...BC
    if (currentUser.role === "SALES") {
      delete filters.locations;
      filters.users = currentUser.id.toString();
    } else {
      if (st.selectedLocations && st.selectedLocations.length > 0) {
        filters.locations = st.selectedLocations.toString();
      }

      //This should only happen on load of the page from going back...BC
      if (st.users && st.users.length > 0) {
        filters.users = st.users;
      }
    }

    this.newSearchFunction(filters);
  }

  saveUserFilters() {
    let obj = {
      dateFilterType: this.state.dateFilterType,
      endDate: this.state.endDate,
      salesServiceClinic: this.state.locationsRadio,
      startDate: this.state.startDate,
      userpreferenceDefaultHiddenColumns:
        this.state.defaultHiddenColumns.map((x) => {
          return { defaultHiddenColumns: x };
        }) || [],
      userpreferenceEquipment:
        this.state.equipmentIds.map((x) => {
          return { equipmentId: parseInt(x) };
        }) || [],
      userpreferenceGroupColumns:
        this.state.groupingColumns.map((x) => {
          return { groupColumns: x };
        }) || [],
      userpreferenceInsurance:
        (this.state.insuranceSelected &&
          this.state.insuranceSelected.length > 0) ||
        (this.state.insuranceSubTypeSelected &&
          this.state.insuranceSubTypeSelected.length > 0)
          ? [
              {
                payors: this.state.insuranceSelected.toString() || "",
                insurance: this.state.insuranceSubTypeSelected.toString() || "",
              },
            ]
          : [],
      userpreferenceInternalLocation: this.state.selectedLocations.map((x) => {
        return { internalLocationId: parseInt(x) };
      }),
      userpreferenceReason:
        this.state.selectedReasonIds.map((x) => {
          return { reasonId: parseInt(x) };
        }) || [],
      userpreferenceSeatingClinics: [],
      userpreferenceStatus:
        this.state.selectedStatuses.map((x) => {
          const matchingStatus = this.state.statusOptions.find((option) => {
            return option.value === String(x) || option.label === x;
          });

          return { statusValue: matchingStatus ? matchingStatus.label : x };
        }) || [],
      userpreferenceTypes: [],
      userpreferenceUser: this.state.users.map((x) => {
        return { userId: x };
      }),
    };

    Setting.set("orders.settings", obj);
    NotistackEnqueueSnackbar("Settings saved successfully!", {
      variant: "success",
    });
  }

  clearUserFilters() {
    this.clearSelectedStatuses();
    this.clearSelectedEquipment();
    this.clearSelectedLocations();
    this.clearSelectedSalesReps();
    this.clearSelectedInsurances();
    this.clearSelectedInsuranceSubTypes();
    //TODO

    Setting.clear("orders.settings");
    NotistackEnqueueSnackbar("Settings have been cleared", {
      variant: "success",
    });
  }

  onLocationsRadioClick = (val) => {
    this.setState({
      locationsRadio: val,
    });
  };

  getStatusOptions() {
    let oldNames = this.state.selectedStatuses,
      a = [];

    a.push({
      checked: oldNames.indexOf("New") > -1 || oldNames.indexOf(0) > -1,
      disabled: false,
      text: "New",
      value: 0,
    });

    a.push({
      checked:
        oldNames.indexOf("InProcess") > -1 ||
        oldNames.indexOf("In Process") > -1 ||
        oldNames.indexOf(1) > -1,
      disabled: false,
      text: "In Process",
      value: 1,
    });

    a.push({
      checked:
        oldNames.indexOf("ReadyToDeliver") > -1 ||
        oldNames.indexOf("Ready to Deliver") > -1 ||
        oldNames.indexOf(2) > -1,
      disabled: false,
      text: "Ready to Deliver",
      value: 2,
    });

    a.push({
      checked:
        oldNames.indexOf("Setup") > -1 ||
        oldNames.indexOf("Set Up") > -1 ||
        oldNames.indexOf(3) > -1,
      disabled: false,
      text: "Setup",
      value: 3,
    });

    a.push({
      checked: oldNames.indexOf("Cancelled") > -1 || oldNames.indexOf(4) > -1,
      disabled: false,
      text: "Cancelled",
      value: 4,
    });

    this.setState({
      allStatuses: a,
    });
  }

  getReasonOptions() {
    const { reasons } = this.context;
    let a = [],
      statuses = this.state.selectedStatuses || [],
      rsns = reasons || this.state.allReasons,
      ids = this.state.reasonIds,
      oldIds = this.state.selectedReasonIds;
    let validReasonIds = [];

    let sortOrder = [
      "New",
      "In Process",
      "Ready to Deliver",
      "Setup",
      "Cancelled",
    ];

    rsns.sort(function (a, b) {
      // Pass a function to the sort that takes 2 elements to compare
      if (a.orderStatus === b.orderStatus) {
        // If the elements both have the same `type`,
        return a.description.localeCompare(b.description); // Compare the elements by `name`.
      } else {
        // Otherwise,
        return a.orderStatus - b.orderStatus;
        //	sortOrder.indexOf(a.orderStatus) - sortOrder.indexOf(b.orderStatus)
        //); // Subtract indexes, If element `a` comes first in the array, the returned value will be negative, resulting in it being sorted before `b`, and vice versa.
      }
    });

    statuses.forEach((selectedStatus) => {
      // Convert status (label or number) to numeric order status.
      let numericOrderStatus;

      if (typeof selectedStatus === "number") {
        numericOrderStatus = selectedStatus;
      } else {
        let matchingStatusOption = this.state.statusOptions.find(
          (option) =>
            option.label === selectedStatus ||
            option.value === String(selectedStatus),
        );
        numericOrderStatus = matchingStatusOption
          ? parseInt(matchingStatusOption.value, 10)
          : parseInt(selectedStatus, 10);
      }

      a.push({
        checked: false,
        disabled: true,
        text: sortOrder[numericOrderStatus],
        value: numericOrderStatus,
      });
      // adding a handler for 'blank' -- AFTER we rework the userpreferences - TODO
      //a.push({
      //	checked: false,
      //	disabled: false,
      //	text: 'Blank',
      //	value: '-',
      //});
      rsns.forEach((reason) => {
        if (numericOrderStatus === reason.orderStatus) {
          validReasonIds.push(reason.id);
          a.push({
            checked:
              ids.includes(reason.id) || oldIds.includes(reason.id) || false,
            disabled: false,
            text: reason.description,
            value: reason.id,
          });
        }
      });
    });

    let filteredSelectedReasonIds = oldIds.filter((reasonId) =>
      validReasonIds.includes(reasonId),
    );
    let filteredReasonIds = ids.filter((reasonId) =>
      validReasonIds.includes(reasonId),
    );

    this.setState({
      availableReasons: a,
      allReasons: reasons,
      selectedReasonIds: filteredSelectedReasonIds,
      reasonIds: filteredReasonIds,
    });
  }

  getLocationOptions() {
    const { allLocations } = this.context;

    let a = [],
      oldIds = this.state.internalLocations || [],
      ids = this.state.locationIds;

    //Must add the checked and disabled for it to remain 'uncontrolled'...BC
    allLocations.map((loc) => {
      let checked = false;

      //If the user filter had old ids in it, set them to default be selected...BC
      if (oldIds.indexOf(loc.id) > -1 || ids.indexOf(loc.id) > -1) {
        checked = true;
      }

      return a.push({
        checked: checked,
        disabled: false,
        text: loc.name,
        value: loc.id,
      });
    });

    this.setState({
      allLocations: a,
    });
  }

  getInsuranceTypes() {
    const { insuranceTypes } = this.context;
    let oldIds = this.state.insuranceSelected,
      ids = this.state.insuranceIds.map((x) => parseInt(x));

    let arr = [];

    insuranceTypes.forEach((ins) => {
      let checked = false;
      if (oldIds.indexOf(ins.id) > -1 || ids.indexOf(ins.id) > -1) {
        checked = true;
      }
      arr.push({
        checked: checked,
        disabled: false,
        text: ins.name,
        value: ins.id,
      });
    });

    this.setState({
      allInsurances: arr,
    });
  }

  getInsuranceSubTypes() {
    const { insuranceSubTypes } = this.context;
    let oldIds = this.state.insuranceSubTypeSelected,
      ids = this.state.insuranceSubTypeIds.map((x) => parseInt(x));

    let arr = [];

    insuranceSubTypes.forEach((ins) => {
      let checked = false;
      if (oldIds.indexOf(ins.id) > -1 || ids.indexOf(ins.id) > -1) {
        checked = true;
      }
      arr.push({
        insuranceType: ins.insuranceType,
        checked: checked,
        disabled: false,
        text: ins.name,
        value: ins.id,
      });
    });

    this.setState({
      allInsuranceSubTypes: arr,
      filteredInsuranceSubTypes: arr,
    });
  }

  filterInsuranceSubTypes(e) {
    let insuranceSubTypes = this.state.allInsuranceSubTypes;

    let ary = [];

    if (e.length === 0) {
      insuranceSubTypes = insuranceSubTypes.map((x) => {
        x.checked = false;
        return x;
      });
      this.setState({
        filteredInsuranceSubTypes: insuranceSubTypes,
      });
      return;
    }

    e.map((insurance) => {
      insuranceSubTypes.map((t) => {
        if (t.insuranceType.id === insurance) {
          return ary.push(t);
        }
        return null;
      });
      return null;
    });
    this.setState({
      filteredInsuranceSubTypes: ary,
    });
  }

  getSalesRepOptions(e) {
    const { salesReps, userprofileLocationsIndexed } = this.context;

    let options = [],
      oldIds = this.state.users || [];

    const selectedLocationIds = e || [];

    salesReps.map((rep) => {
      const repHasMatchingLocation =
        !selectedLocationIds ||
        selectedLocationIds.length === 0 ||
        Object.values(userprofileLocationsIndexed).some(
          (userprofileLocation) => {
            return (
              userprofileLocation.userprofileId === rep.id &&
              selectedLocationIds.includes(userprofileLocation.locationsId)
            );
          },
        );

      if (rep.active === true && repHasMatchingLocation) {
        let checked = false;

        if (oldIds.indexOf(rep.id) > -1) {
          checked = true;
        }

        options.push({
          disabled: false,
          checked: checked,
          text: rep.firstname + " " + rep.lastname,
          value: rep.id,
        });
      }

      return null;
    });

    if (salesReps.length !== 0) {
      this.setState({
        filteredSalesReps: options,
        allSalesReps: salesReps,
        updatedCheckedReps: true,
      });
    }
  }

  getEquipmentOptions() {
    const { productTypes } = this.context;

    let a = [],
      oldIds = this.state.equipmentIds;

    //Must add the checked and disabled for it to remain 'uncontrolled'...BC
    productTypes.map((prod) => {
      let checked = false;

      //If the user filter had old ids in it, set them to default be selected...BC
      if (oldIds.indexOf(prod.id) > -1) {
        checked = true;
      }

      return a.push({
        checked: checked,
        disabled: false,
        text: prod.name,
        value: prod.id.toString(),
      });
    });

    this.setState({
      allEquipment: a,
    });
  }

  renderDates() {
    let st = this.state;
    return (
      <>
        <div>
          <MDBRow>
            <Col size="12" style={{ zIndex: "1000" }}>
              <Select
                placeholder="Quick Filter"
                options={st.quickFilterOptions}
                onChange={this.handleQuickFilter.bind(this)}
                value={st.quickFilterSelected}
              />
            </Col>
          </MDBRow>

          {st.showDatePicker ? (
            <MDBRow style={{ marginTop: 10, marginBottom: 10 }}>
              <Col size="6" className={"inputDateWrapper uiDateOutline"}>
                <MUIDatePicker
                  label="Start Date"
                  value={st.startDate ? moment(st.startDate) : null}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      variant: "outlined",
                      InputLabelProps: {
                        shrink: true,
                      },
                    },
                  }}
                  onChange={(e) => this.setState({ startDate: new Date(e._d) })}
                  views={["year", "month", "day"]}
                />
              </Col>

              <Col size="6" className={"inputDateWrapper uiDateOutline"}>
                <MUIDatePicker
                  label="End Date"
                  value={st.endDate ? moment(st.endDate) : null}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      variant: "outlined",
                      InputLabelProps: {
                        shrink: true,
                      },
                    },
                  }}
                  onChange={(e) => this.setState({ endDate: new Date(e._d) })}
                  views={["year", "month", "day"]}
                />
              </Col>
            </MDBRow>
          ) : (
            <div style={{ margin: "68px" }}>
              <div
                style={{ marginLeft: "15px", marginRight: "55px" }}
                className="spinner-border text-info"
                role="status"
              >
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  handleQuickFilter = (e) => {
    let a = QuickFilter.getDates(e.value),
      st = this.state,
      t = this;

    if (a.length > 0) {
      st.startDate = a[0];
      st.endDate = a[1];
    } else {
      st.startDate = "";
      st.endDate = "";
    }

    this.setState({
      quickFilter: a,
      dateFilterType: e.value,
      startDate: st.startDate,
      endDate: st.endDate,
      showDatePicker: false,
      quickFilterSelected: e,
    });

    setTimeout(() => {
      t.setState({
        showDatePicker: true,
      });
    }, 500);
  };

  renderStatuses() {
    const options = this.state.statusOptions;
    const resolveOption = (status) => {
      if (status == null) return null;

      return options.find(
        (option) => option.label === status || option.value === String(status),
      );
    };
    const selectedOptions = (this.state.selectedStatuses || [])
      .map(resolveOption)
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(opt) => opt.label}
            isOptionEqualToValue={(a, b) => a.value === b.value}
            onChange={(_, newValue) => {
              this.getStatusValue(newValue.map((o) => Number(o.value)));
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Statuses"
                variant="outlined"
                size="small"
                placeholder={selectedOptions.length ? "" : "Choose Statuses"}
              />
            )}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            style={{ paddingTop: 20, marginLeft: "30px" }}
            onClick={this.clearSelectedStatuses.bind(this)}
          />
        </Col>
      </Row>
    );
  }

  getStatusValue(e) {
    this.setState(
      {
        selectedStatuses: e,
      },
      () => {
        this.getReasonOptions();
      },
    );
  }

  clearSelectedStatuses() {
    let t = this;

    this.setState({
      statuses: [],
      selectedStatuses: [],
    });

    this.state.allStatuses.forEach((stat) => {
      stat.checked = false;
    });

    setTimeout(() => {
      t.getStatusOptions();
      t.clearSelectedReasons();
    }, 100);
  }

  renderReasons() {
    const options = this.state.availableReasons;
    const selectedOptions = (this.state.selectedReasonIds || [])
      .map((selectedReasonId) => {
        if (selectedReasonId == null) {
          return null;
        }
        return options.find((option) => option.value == selectedReasonId);
      })
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.text}
            isOptionEqualToValue={(a, b) => a.value == b.value}
            getOptionDisabled={(option) => option.disabled}
            onChange={(_, newValue) => {
              this.getReasonValue(newValue.map((option) => option.value));
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Reasons"
                variant="outlined"
                size="small"
                placeholder={selectedOptions.length ? "" : "Choose Reasons"}
              />
            )}
            slotProps={{
              listbox: { style: { maxHeight: 300 } },
            }}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            onClick={this.clearSelectedReasons.bind(this)}
            style={{ paddingTop: 20, marginLeft: "30px" }}
          />
        </Col>
      </Row>
    );
  }

  getReasonValue(e) {
    //let res = e && e.length > 0 ? e.map(x => x.id) : [];
    this.setState({
      selectedReasonIds: e || [],
    });
  }

  clearSelectedReasons() {
    let t = this,
      r = this.state.availableReasons.slice();

    r.forEach((res) => {
      res.checked = false;
    });

    this.setState({
      selectedReasonIds: [],
      //reasonIds: [],
      availableReasons: r,
    });

    setTimeout(() => {
      t.getReasonOptions();
    }, 100);
  }

  renderLocationType() {
    return (
      <Row style={{ marginLeft: "5px" }}>
        <MDBCol size="6">
          <Input
            onClick={() => this.onLocationsRadioClick("Sales")}
            checked={this.state.locationsRadio === "Sales"}
            label="Sales"
            type="radio"
            id="salesLocations"
          />
        </MDBCol>

        <MDBCol size="6">
          <Input
            onClick={() => this.onLocationsRadioClick("Service")}
            checked={this.state.locationsRadio === "Service"}
            label="Service"
            type="radio"
            id="serviceLocations"
          />
        </MDBCol>
      </Row>
    );
  }

  renderLocations() {
    const options = this.state.allLocations;
    const resolveOption = (id) => {
      if (id == null) return null;
      return options.find((option) => option.value == id);
    };
    const selectedOptions = (this.state.selectedLocations || [])
      .map(resolveOption)
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.text}
            isOptionEqualToValue={(a, b) => a.value == b.value}
            onChange={(_, newValue) => {
              this.getLocationValue(newValue.map((option) => option.value));
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Locations"
                variant="outlined"
                size="small"
                placeholder={selectedOptions.length ? "" : "Choose Locations"}
              />
            )}
            slotProps={{
              listbox: { style: { maxHeight: 300 } },
            }}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            style={{ paddingTop: 20, marginLeft: "30px" }}
            onClick={this.clearSelectedLocations.bind(this)}
          />
        </Col>
      </Row>
    );
  }

  getLocationValue(e) {
    this.setState({
      selectedLocations: e,
    });
    this.getSalesRepOptions(e);
  }

  clearSelectedLocations() {
    let t = this;

    this.setState({
      locationIds: [],
      selectedLocations: [],
    });

    this.state.allLocations.forEach((loc) => {
      loc.checked = false;
    });

    setTimeout(() => {
      t.getLocationOptions();
    }, 100);
  }

  renderSalesReps() {
    const options = this.state.filteredSalesReps;
    const resolveOption = (id) => {
      if (id == null) return null;
      return options.find((option) => option.value == id);
    };
    const selectedOptions = (this.state.users || [])
      .map(resolveOption)
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.text}
            isOptionEqualToValue={(a, b) => a.value == b.value}
            onChange={(_, newValue) => {
              this.getSalesRepsValue(newValue.map((option) => option.value));
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Sales Reps"
                variant="outlined"
                size="small"
                placeholder={selectedOptions.length ? "" : "Choose Sales Reps"}
              />
            )}
            slotProps={{
              listbox: { style: { maxHeight: 300 } },
            }}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            onClick={this.clearSelectedSalesReps.bind(this)}
            style={{ paddingTop: 20, marginLeft: "30px" }}
          />
        </Col>
      </Row>
    );
  }

  getSalesRepsValue(e) {
    this.setState({
      users: e,
    });
  }

  clearSelectedSalesReps() {
    let ary = [];

    this.state.filteredSalesReps.forEach((rep) => {
      rep.checked = false;
      ary.push(rep);
    });

    this.setState({
      users: [],
      filteredSalesReps: ary,
    });

    setTimeout(() => {
      this.getSalesRepOptions(this.state.selectedLocations);
    }, 100);
  }

  renderEquipment() {
    const options = this.state.allEquipment;
    const resolveOption = (id) => {
      if (id == null) return null;
      return options.find((option) => option.value == id);
    };
    const selectedOptions = (this.state.equipmentIds || [])
      .map(resolveOption)
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.text}
            isOptionEqualToValue={(a, b) => a.value == b.value}
            onChange={(_, newValue) => {
              this.getEquipmentValue(newValue.map((option) => option.value));
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Equipment"
                variant="outlined"
                size="small"
                placeholder={selectedOptions.length ? "" : "Choose Equipment"}
              />
            )}
            slotProps={{
              listbox: { style: { maxHeight: 300 } },
            }}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            onClick={this.clearSelectedEquipment.bind(this)}
            style={{ paddingTop: 20, marginLeft: "30px" }}
          />
        </Col>
      </Row>
    );
  }

  renderInsurance() {
    const options = this.state.allInsurances;
    const resolveOption = (id) => {
      if (id == null) return null;
      return options.find((option) => option.value == id);
    };
    const selectedOptions = (this.state.insuranceIds || [])
      .map(resolveOption)
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.text}
            isOptionEqualToValue={(a, b) => a.value == b.value}
            onChange={(_, newValue) => {
              this.getInsuranceValue(newValue.map((option) => option.value));
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Payor Source"
                variant="outlined"
                size="small"
                placeholder={
                  selectedOptions.length ? "" : "Choose Payor Source"
                }
              />
            )}
            slotProps={{
              listbox: { style: { maxHeight: 300 } },
            }}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            onClick={this.clearSelectedInsurances.bind(this)}
            style={{ paddingTop: 20, marginLeft: "30px" }}
          />
        </Col>
      </Row>
    );
  }

  renderInsuranceSubType() {
    const options = this.state.filteredInsuranceSubTypes;
    const resolveOption = (id) => {
      if (id == null) return null;
      return options.find((option) => option.value == id);
    };
    const selectedOptions = (this.state.insuranceSubTypeSelected || [])
      .map(resolveOption)
      .filter(Boolean);

    return (
      <Row style={{ marginLeft: "-15px" }}>
        <Col size="10" className="insuranceSelects">
          <MUIAutocomplete
            multiple
            disableCloseOnSelect
            options={options}
            value={selectedOptions}
            getOptionLabel={(option) => option.text}
            isOptionEqualToValue={(a, b) => a.value == b.value}
            onChange={(_, newValue) => {
              this.getInsuranceSubTypeValue(
                newValue.map((option) => option.value),
              );
            }}
            sx={{ marginLeft: "13px", width: "100%" }}
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choose Insurance"
                variant="outlined"
                size="small"
                placeholder={selectedOptions.length ? "" : "Choose Insurance"}
              />
            )}
            slotProps={{
              listbox: { style: { maxHeight: 300, maxWidth: 280 } },
            }}
          />
        </Col>
        <Col size="1">
          <MUICloseIcon
            onClick={this.clearSelectedInsuranceSubTypes.bind(this)}
            style={{ paddingTop: 20, marginLeft: "30px" }}
          />
        </Col>
      </Row>
    );
  }

  getEquipmentValue(e) {
    this.setState({
      equipmentIds: e,
    });
  }

  getInsuranceValue(e) {
    this.setState({
      insuranceSelected: e || [],
      insuranceIds: e,
    });
    this.filterInsuranceSubTypes(e);
  }

  getInsuranceSubTypeValue(e) {
    this.setState({
      insuranceSubTypeSelected: e,
    });
  }

  clearSelectedEquipment() {
    let t = this;

    this.setState({
      equipmentIds: [],
    });

    this.state.allEquipment.forEach((eq) => {
      eq.checked = false;
    });

    setTimeout(() => {
      t.getEquipmentOptions();
    }, 100);
  }

  clearSelectedInsurances() {
    let ai = this.state.allInsurances;
    ai = ai.map((x) => {
      x.checked = false;
      return x;
    });
    this.setState({
      insuranceIds: [],
      insuranceSelected: [],
      allInsurances: ai,
    });
    this.clearSelectedInsuranceSubTypes();
  }

  clearSelectedInsuranceSubTypes() {
    var items = this.state.filteredInsuranceSubTypes;
    items = items.map((x) => {
      x.checked = false;
      return x;
    });
    this.setState({
      insuranceSubTypeSelected: [],
      insuranceSubTypeIds: [],
      filteredInsuranceSubTypes: items,
    });
  }

  //method to hide/show the location filters based on if you are a sales rep or not...BC
  renderLocationUserFilters() {
    const { currentUser } = this.context;
    if (currentUser && currentUser.role !== "SALES") {
      return (
        <div>
          <Col size="12">{this.renderLocations()}</Col>

          <Col size="12">{this.renderSalesReps()}</Col>
        </div>
      );
    }
    return <div />;
  }

  render() {
    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <Card style={{ color: "rgba(0, 0, 0, 0.87)" }}>
          <CardBody>
            <Row style={{ marginLeft: "20px", marginRight: "20px" }}>
              <Col size="12">{this.renderDates()}</Col>

              <Col size="12">{this.renderStatuses()}</Col>

              <Col size="12">{this.renderReasons()}</Col>

              <div style={{ width: "100%" }}>
                {this.renderLocationUserFilters()}
              </div>

              <Col size="12">{this.renderEquipment()}</Col>
              {/*TODO uncomment when ready to implement*/}
              <Col size="12">{this.renderInsurance()}</Col>

              <Col size="12">{this.renderInsuranceSubType()}</Col>

              <Col size="12" style={{ paddingTop: 10, paddingBottom: 10 }}>
                {this.renderLocationType()}
              </Col>
            </Row>

            <Row style={{ justifyContent: "space-around" }}>
              <Button
                floating
                size="sm"
                color={"indigo"}
                data-tip={"Search"}
                onClick={this.newSearchPass.bind(this, this.state)}
              >
                <MUISearchIcon style={{ fontSize: "2em" }} />
              </Button>

              <Button
                floating
                size="sm"
                color={"success"}
                data-tip={"Save Filters"}
                onClick={this.saveUserFilters.bind(this)}
              >
                <MUISaveIcon style={{ fontSize: "2em" }} />
              </Button>

              <Button
                floating
                size="sm"
                color={"warning"}
                data-tip={"Clear Filters"}
                onClick={this.clearUserFilters.bind(this)}
              >
                <MUIBackspaceIcon style={{ fontSize: "2em" }} />
              </Button>

              <ReactTooltip />
            </Row>
          </CardBody>
        </Card>
      </ThemeProvider>
    );
  }
}
